import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { AgreementsClient } from '@unity/clients';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { CardBudgetSummarySharedComponent } from '@unity/shared/card-budget-summary-shared/card-budget-summary-shared.component';
import { CardItemCountSummarySharedComponent } from '@unity/shared/card-item-count-summary-shared/card-item-count-summary-shared.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridClientSharedComponent } from '@unity/shared/grid-client-shared/grid-client-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-client-page',
  imports: [
    PageContainerComponent,
    GridClientSharedComponent,
    ActionSharedComponent,
    CardItemCountSummarySharedComponent,
    CardBudgetSummarySharedComponent,
  ],
  templateUrl: './list-client-page.component.html',
  styleUrl: './list-client-page.component.scss',
})
export class ListClientPageComponent {
  private readonly agreementsClient = inject(AgreementsClient);

  public readonly $agreementId = input.required({ alias: 'agreementId', transform: (value: string) => parseInt(value) });

  protected readonly agreementResource = rxResource({
    params: () => {
      const agreementId = this.$agreementId();
      return agreementId ? { agreementId } : undefined;
    },
    stream: ({ params: { agreementId } }) => this.agreementsClient.getOneAsMini(agreementId),
  });

  protected readonly agreementStatsResource = rxResource({
    params: () => {
      const agreementId = this.$agreementId();
      return agreementId ? { agreementId } : undefined;
    },
    stream: ({ params: { agreementId } }) => this.agreementsClient.getOneAsStats(agreementId),
  });

  protected readonly $createClientAction = computed(() => {
    const agreementId = this.$agreementId();
    return QuickActions.CreateClient(agreementId);
  });

  protected readonly $agreement = computed(() => (this.agreementResource.hasValue() ? this.agreementResource.value() : undefined));

  protected readonly $agreementStats = computed(() =>
    this.agreementStatsResource.hasValue() ? this.agreementStatsResource.value() : undefined
  );

  protected readonly $contentHeaderSecondary = computed(() => {
    const agreement = this.$agreement();
    return `Agreement: ${agreement?.name}`;
  });

  protected readonly $returnToAgreementAction = computed(() => QuickActions.ReturnToAgreement(this.$agreementId()));
}
